module.exports = require("webpack-dev-middleware");


//////////////////
// WEBPACK FOOTER
// external "webpack-dev-middleware"
// module id = 51
// module chunks = 0